// extracted by mini-css-extract-plugin
module.exports = {"select":"VistaPeriodo_select__keoUw","viz":"VistaPeriodo_viz__3Dt7Q"};